import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function About() {
  return <section id="about" className="py-32 relative z-20 bg-zinc-950" data-id="element-5" data-mp="2prgyj3mdudc7">
      <div className="max-w-7xl mx-auto px-6" data-id="element-6" data-mp="2prqncnvoyegb">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-start" data-id="element-7" data-mp="2tskavg581r8o">
          {/* Left Column */}
          <div className="lg:col-span-5" data-id="element-8" data-mp="2yt7zxw9w3y09">
            <FadeIn data-id="element-9" data-mp="2yq2eqs4dtg9t">
              <span className="text-sm font-medium tracking-widest uppercase text-zinc-500 mb-6 block" data-id="element-10" data-mp="33rhx2cf6d8oi">
                About MUNISVERSE
              </span>
              <h2 className="text-4xl md:text-5xl font-display font-medium leading-tight text-white" data-id="element-11" data-mp="38oi3wpjumfgo">
                Redefining how you experience space.
              </h2>
            </FadeIn>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-7 space-y-8 text-lg md:text-xl text-zinc-400 font-light leading-relaxed" data-id="element-12" data-mp="3mhzmo84pno5n">
            <FadeIn delay={0.1} data-id="element-13" data-mp="3rgay2nanm6pz">
              <p data-id="element-14" data-mp="3rhc8qqnrcr76">
                MUNISVERSE is a PropTech company combining real estate
                expertise with immersive technology to improve how properties
                are experienced, presented and documented.
              </p>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-15" data-mp="2cq0y3mccqb4f">
              <p data-id="element-16" data-mp="2cr2l8p6n6o2i">
                From virtual tours and valuation scans to construction
                documentation, virtual staging and 3D development
                visualisation, we create digital property experiences that make
                spaces easier to explore, understand and communicate.
              </p>
            </FadeIn>
            <FadeIn delay={0.3} data-id="element-17" data-mp="2vpeu09tn5vxk">
              <p data-id="element-18" data-mp="2vod7n976dn0j">
                We are building a better digital connection between physical
                properties and the people who need to experience them.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}